export default [
  {
    path: '/dashboard/FhIP5j93934HnVYRAwU66Osbw7jQP98u4z61zTx3n79JmLChBbrw6',
    name: 'admin-home-root',
    component: () => import('../views/newAdmin/Home.vue'),
    meta: {
      title: 'Dashboard admin',
      requiresAuth: true
    },
  },
  {
    path: '/dashboard/inicio',
    name: 'admin-home',
    component: () => import('../views/admin/Home.vue'),
    meta: {
      title: 'Inicio',
      requiresAuth: true
    },
  },
  {
    path: '/dashboard/lite',
    name: 'lite-admin-home',
    component: () => import('../views/admin/LiteDashboard.vue'),
    meta: {
      title: 'Dashboard lite',
      requiresAuth: true
    },
  },
  {
    path: '/dashboard/perfil',
    name: 'admin-profile',
    component: () => import('../views/admin/Profile.vue'),
    meta: {
      title: 'Perfil de usuario',
      requiresAuth: true
    },
  },
  {
    path: '/dashboard/eventos',
    name: 'admin-events',
    component: () => import('../views/admin/MyEvents.vue'),
    meta: {
      title: 'Mis eventos',
      requiresAuth: true
    },
  },
  {
    path: '/dashboard/nuevo-evento',
    name: 'admin-new-event',
    component: () => import('../views/admin/NewEvent.vue'),
    meta: {
      title: 'Nuevo evento',
      requiresAuth: true
    },
  },
  {
    path: '/dashboard/nuevo-evento-lite',
    name: 'admin-new-event-lite',
    component: () => import('../views/admin/LiteNewEvent.vue'),
    meta: {
      title: 'Nuevo evento lite',
      requiresAuth: true
    },
  },
  {
    path: '/dashboard/modificar-evento/:id',
    name: 'admin-update-event',
    component: () => import('../views/admin/NewEvent.vue'),
    meta: {
      title: 'Modificar evento',
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: true,
        },
        {
          text: 'Modificación de evento',
          disabled: true,
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/dashboard/modificar-evento-lite/:id',
    name: 'admin-update-event-lite',
    component: () => import('../views/admin/LiteNewEvent.vue'),
    meta: {
      title: 'Modificar evento',
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: true,
        },
        {
          text: 'Modificación de evento',
          disabled: true,
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/dashboard/nuevo-evento/vista-previa',
    name: 'admin-new-event-preview',
    component: () => import('../views/admin/EventPreview.vue'),
    meta: {
      title: 'Vista previa',
      requiresAuth: true
    },
  },
  {
    path: '/dashboard/eventos/:id/asistentes',
    name: 'admin-assistants-details',
    component: () => import('../views/admin/Assistants.vue'),
    meta: {
      title: 'Asistentes',
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: true,
        },
        {
          text: 'Asistentes',
          disabled: true,
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/dashboard/eventos/:id/asistentes-evento',
    name: 'admin-assistants-paginate-details',
    component: () => import('../views/admin/AttendeesPaginate.vue'),
    meta: {
      title: 'Asistentes',
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: true,
        },
        {
          text: 'Asistentes',
          disabled: true,
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/dashboard/afiliaciones',
    name: 'admin-affiliations',
    component: () => import('../views/admin/MyPlans.vue'),
    meta: {
      title: 'Afiliaciones',
      requiresAuth: true
    }
  },
  {
    path: '/dashboard/modificar-afiliacion/:id',
    name: 'admin-update-affiliation',
    component: () => import('../views/admin/NewPlan.vue'),
    meta: {
      title: 'Modificar afiliación',
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: true,
        },
        {
          text: 'Modificación de afiliación',
          disabled: true,
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/dashboard/nueva-afiliacion',
    name: 'admin-new-affiliation',
    component: () => import('../views/admin/NewPlan.vue'),
    meta: {
      title: 'Nueva afiliación',
      requiresAuth: true
    }
  },
  {
    path: '/dashboard/afiliaciones/:id/afiliados',
    name: 'admin-affiliates-details',
    component: () => import('../views/admin/Affiliates.vue'),
    meta: {
      title: 'Afiliados',
      breadcrumbs: [
        {
          text: 'Dashboard',
          disabled: true,
        },
        {
          text: 'Afiliados',
          disabled: true,
        },
      ],
      requiresAuth: true
    },
  },
  {
    path: '/dashboard/checkin',
    name: 'admin-checkin',
    component: () => import('../views/admin/CheckIn.vue'),
    meta: {
      title: 'Checkin de Eventos',
      requiresAuth: true
    },
  }
]